import { Code, ConnectError } from '@connectrpc/connect';
import { registryRecordClient } from '../registryRecordClient';
export const vehicleClient = {
    async dossier (vehicleId) {
        try {
            return await registryRecordClient.getVehicleDossier({
                vehicleId
            });
        } catch (error) {
            if (error instanceof ConnectError && [
                Code.NotFound,
                Code.PermissionDenied
            ].includes(error.code)) return null;
            throw error;
        }
    },
    holders: (vehicleId)=>registryRecordClient.listVehicleHolders({
            vehicleId
        }),
    rounds: (vehicleId, fromYear, toYear)=>registryRecordClient.listVehicleTaskOrderRounds({
            vehicleId,
            fromYear,
            toYear
        }),
    lineage: (vehicleId)=>registryRecordClient.listVehicleLineage({
            vehicleId
        }),
    saveLineage: registryRecordClient.saveVehicleLineage,
    archiveLineage: registryRecordClient.archiveVehicleLineage
};
